import angular from 'angular';
import { environment } from 'environments';


(() => {
  class Pharmacy {
    constructor(BaseService, ngDialog, Endpoints) {
      'ngInject';

      Object.assign(this, { ...BaseService, ngDialog, Endpoints });

      this.whitelist = [
        'lat',
        'lng',
        'radius',
        'name',
        'road',
        'city',
        'state',
        'zip',
        'phone',
        'specialties',
        'service_levels',
        'paged_format',
        'limit',
        'offset',
      ];

      this.selectableSpecialties = [
        // { display: 'Lemonaid Mail Order', code: 'mail_order_lemonaid', selected: false },
        { display: 'Pharmacy Pick Up', code: 'retail', selected: false },
        { display: 'Insurance Mail Order', code: 'mail_order', selected: false },

        // { display: '', code: '24_hour_store', selected: false },
        // { display: '', code: 'fax_pharmacy_surescripts', selected: false },
        // { display: '', code: 'long_term_care', selected: false },
        // { display: '', code: 'specialty', selected: false },
      ];

      this.specialties = [
        '24_hour_store',
        'fax_pharmacy_surescripts',
        'long_term_care',
        'mail_order',
        'retail',
        'specialty',
      ];

      this.serviceLevels = [
        'new_rx',
        'refill',
        'change',
        'rx_fill',
        'cancel',
        'med_history',
        'eligibility',
        'resupply',
        'census',
        'ccr',
        'epcs',
      ];
    }

    getMailorderPharmacy(medication_id, state_code) {
      return this.$http.get(`${this.API_URL}/medications/${medication_id}/states/${state_code}/mailorderpharmacies/default`);
    }

    search(query = {}) {
      const filtered = this.filterParams(query, this.whitelist);
      const arrayKeys = ['specialties', 'service_levels'];

      for (const key of arrayKeys) {
        if (Array.isArray(filtered[key]) && filtered[key].length) {
          filtered[key] = filtered[key].map(s => s.code);
        } else {
          delete filtered[key];
        }
      } // ON SPRINT 107:
      // AS WE DISCUSSED WITH CHARUL
      // WE FOUND FRONTEND IS ALWAYS SENDING THIS PARAMETER 'add_mail_order=true'
      // THIS IS ADDING MORE PHARMACIES TO THE RESULT SIMILAR TO 'specialties=mail_order'
      // BUT WE ALREADY HAVE THIS PARAMETER / FILTER ON THE DROPDOWN SO WE DON'T NEED TO USE IT
      // EVEN MORE, IT IS CAUSING THE FILTERS TO NOT BE WORKING AS EXPECTED
      // SO WE ARE COMMENTING THIS PARAMETER
      // filtered.add_mail_order = true;


      const queryString = this.serializeQuery(filtered);
      return this.$http.get(`${this.API_URL}/pharmacies/${queryString}`);
    }

    fetch(pharmacyId) {
      return this.$http.get(`${this.API_URL}/pharmacies/${pharmacyId}`);
    }

    geocode(address) {
      return this.$http.get(this.Endpoints.google.geocode.replace(':address', address).replace(':key', environment.constants.GOOGLE_MAPS_KEY), {
        loadingText: `Searching around ${address}`
      });
    }
    /**
     * Creates dialog in browser window to search for pharmacies
     * @param {object} address - an address used to prefill certain query fields
     * @param {boolean} autoRefillTab - a boolean if modal is being called from Auto Refill tab
     * @param {function} callback - a function to call when pharmacy
     *                            is selected or window is closed
     * @returns {object} ngdialog instance
     */
    openSearchDialog(address = {}, autoRefillTab= false) {
      return new Promise((resolve) => {
        this.ngDialog.open({
          template: 'app/components/pharmacy-select/pharmacy-select.html',
          controller: 'PharmaciesController',
          controllerAs: '$ctrl',
          data: {
            address,
            autoRefillTab
          },
          /**
           * @param {string|object} res - res will be an object if a pharmacy is selected
           */
          preCloseCallback(res) {
            resolve(typeof res === 'object' ? res : false);
          },
        });
      });
    }

    confirmMailorderPharmacy(isMailorderOnly, mailorderPharmacy, medication, visitState, callback) {
      return this.ngDialog.open({
        template: 'app/components/mailorder-pharmacy-confirm/mailorder-pharmacy-confirm.html',
        controller: 'MailorderPharmacyController',
        controllerAs: 'mailorder',
        data: {
          isMailorderOnly,
          mailorderPharmacy,
          medication,
          visitState
        },

        /**
         * @param {string|object} res - res will be an object if a pharmacy is selected
         */
        preCloseCallback(res) {
          if (typeof res === 'object') {
            return callback(res);
          }
          return callback(false);
        }

      });
    }

    updatePharmacy({ manager_name, manager_email, id }) {
      return this.$http.put(
        this.Endpoints.pharmacies.putManagerDetails.replace(':pharmacy_id', id),
        {
          manager_name,
          manager_email,
        }
      );
    }

  //   openMailOrder(visit) {
  //     this.ngDialog.open({
  //       templateUrl: 'app/components/charge-mailorder/charge-mailorder.html',
  //       controller: 'MailOrderController',
  //       controllerAs: 'mailOrder',
  //       className: 'ngdialog-theme-default chat-modal',
  //       data: {
  //         visit,
  //       },
  //     });
  // }

  }

  Pharmacy.$inject = ["BaseService", "ngDialog", "Endpoints"];
  angular.module('pims').service('Pharmacy', Pharmacy);
})();
